import { FormEvent, useState } from "react";

import { sendPasswordResetEmail } from "../../../api/users/passwordResetEmail";
import { translationsContent } from "../../../localization/translations";
import { useLanguage } from "../../../store/lang.context";
import { useLoader } from "../../../store/loader.context";
import { translate } from "../../../utils/translate";
import { passwordSchema, validateEmail } from "../../../utils/validations";
import Input from "../../ui/input/SimpleInput";
import SimpleModal from "../../ui/modal/SimpleModal";
import classes from "./passwordReset.module.scss";
import Popup from "./Popup";

interface Props {
  setPasswordResetIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export type PasswordResetModelType = {
  username: string;
};

const passwordResetObject = {
  username: { value: "", isValid: true },
};

const PasswordReset = ({ setPasswordResetIsOpen }: Props) => {
  const [emailSentModalIsOpen, setEmailSentModalIsOpen] = useState(false);
  const [formData, setFormData] = useState(passwordResetObject);
  const { setLoader } = useLoader();
  const { language } = useLanguage();
  const [error, setError] = useState(false);

  const handleInputChange = (
    identifier: keyof PasswordResetModelType,
    value: string
  ) => {
    setFormData((FormDataPreviousState) => ({
      ...FormDataPreviousState,
      [identifier]: {
        value,
        isValid: !passwordSchema.validate({ [identifier]: value }).error,
      },
    }));
  };

  const email = async (event: FormEvent) => {
    event.preventDefault();
    setLoader(true);
    const user = {
      email: formData.username.value,
    };
    const validate = validateEmail.validate(user);
    if (validate.error) {
      setError(true);
      for (const key in formData) {
        const validationItem = formData[key as keyof PasswordResetModelType];
        const tmpValidate = validateEmail.validate({
          [key]: validationItem.value,
        });
        if (tmpValidate.error)
          setFormData((prevState) => ({
            ...prevState,
            [key]: {
              value: validationItem.value,
              isValid: false,
            },
          }));
      }
      setLoader(false);
      return;
    }
    setError(false);

    const isSent = await sendPasswordResetEmail(user);
    if (isSent.success) {
      setEmailSentModalIsOpen(true);
      setError(false);
    } else {
      setError(true);
    }
    setLoader(false);
  };

  return (
    <>
      <SimpleModal setModalIsOpen={setPasswordResetIsOpen}>
        <h2 className={classes.heading}>Veuillez saisir votre e-mail</h2>
        <form className={classes.inputs} id="passwordResetEmailForm">
          <Input<PasswordResetModelType, "username">
            isValid={formData.username.isValid}
            error={error}
            name="email"
            type="email"
            placeholder="Entrez votre adresse e-mail"
            required
            label="Adresse e-mail*"
            identifier="username"
            onChange={handleInputChange}
          />
          {error && (
            <p style={{ color: "red" }}>
              {translate(translationsContent, "setEmailError", language)}
            </p>
          )}
          <button
            className={`${classes.button} ${
              false ? classes.disabledOutline : ""
            }`}
            onClick={(e) => {
              email(e);
            }}
            disabled={formData.username.value === ""}
          >
            {emailSentModalIsOpen
              ? "REVENIR À L'ECRAN DE CONNEXION"
              : "VALIDER"}
          </button>
          {emailSentModalIsOpen && (
            <Popup
              setEmailSentIsOpen={setEmailSentModalIsOpen}
              setPasswordResetIsOpen={setPasswordResetIsOpen}
            />
          )}
        </form>
      </SimpleModal>
    </>
  );
};

export default PasswordReset;
